(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fec-site-header"] && !Shopify.designMode) return;
  try {
    // One sitewide count owner. No fetch interception, polling, or commerce permission.
  (() => {
    if (window.FECCartIndicator) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let client = null, unsubscribe = null, epoch = 0, read = null, revision = 0;
    let count = null, known = false, queued = false, pulseTimer = null, pulseFrame = null;
    let initialized = false, returnTask = null;
    const links = () => [...document.querySelectorAll('[data-fec-cart-link]')];
    const quantity = cart => {
      if (!cart || !Array.isArray(cart.items)) return null;
      let sum = 0;
      for (const line of cart.items) {
        if (!Number.isSafeInteger(line.quantity) || line.quantity <= 0) return null;
        sum += line.quantity;
      }
      return Number.isSafeInteger(sum) ? sum : null;
    };
    const cancelPulse = () => {
      clearTimeout(pulseTimer); if (pulseFrame !== null) cancelAnimationFrame(pulseFrame);
      pulseTimer = pulseFrame = null;
      links().forEach(link => link.classList.remove('is-cart-celebrating'));
    };
    const visible = () => document.visibilityState !== 'hidden' && !document.querySelector('dialog[open]') && links().some(link => link.getClientRects().length);
    const celebrate = () => {
      if (!known || !count || motion.matches) { queued = false; cancelPulse(); return; }
      if (!visible()) { queued = true; return; }
      queued = false; cancelPulse();
      pulseFrame = requestAnimationFrame(() => {
        pulseFrame = null;
        if (!known || !count || motion.matches) return;
        if (!visible()) { queued = true; return; }
        links().forEach(link => link.classList.add('is-cart-celebrating'));
        // CSS is exactly two 1.35s cycles. This is a one-shot cleanup, not a loop.
        pulseTimer = setTimeout(cancelPulse, 2750);
      });
    };
    function display(next, confirmed) {
      if (next !== null) count = next;
      known = confirmed && next !== null;
      if (!known || !count) { queued = false; cancelPulse(); }
      links().forEach(link => {
        link.dataset.fecCartState = known ? 'confirmed' : 'unknown';
        link.classList.toggle('has-cart-items', known && count > 0);
        const badge = link.querySelector('[data-fec-cart-count]');
        // Stale/unknown is never presented as an empty cart or a confirmed number.
        badge.hidden = known && count === 0;
        const text = known ? (count > 99 ? '99+' : String(count)) : '—';
        if (badge.textContent !== text) badge.textContent = text;
        const label = !known ? 'Your cart, item count unavailable. Open to review.' : count ? `Your cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Your cart, empty';
        if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      });
    }
    function state(s) {
      if (s.busy) return; // Keep last confirmed quantity while a serialized read is in flight.
      const next = quantity(s.cart);
      // Business/price/plan validation errors do not invalidate a readable native cart.
      // Transport/read failures can leave a stale cart in the engine: mark it unknown.
      const unreadable = /unreadable cart|request failed|failed to fetch|network|load failed|timed out|rate.limit|unexpected token|json/i.test(s.error || '');
      display(next, next !== null && !s.uncertain && !unreadable);
    }
    function attach() {
      const next = window.FECNativeCartUI?.client;
      if (!next || next === client) return !!client;
      epoch++; if (read) read.abort(); read = null;
      unsubscribe?.(); client = next; revision = 0;
      unsubscribe = client.subscribe(s => {
        // Empty pre-initialization snapshot must not erase Liquid's real server count.
        if (s.cart || s.error || s.uncertain) state(s);
      });
      return true;
    }
    async function reconcile() {
      if (document.visibilityState === 'hidden') return;
      attach();
      if (client) {
        // Its current operation already owns its authoritative readback. Never race it.
        if (client.snapshot().busy) return;
        try { await client.refresh(); } catch (_) { state(client.snapshot()); }
        return;
      }
      if (read) return;
      const ticket = ++epoch, controller = new AbortController(); read = controller;
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        if (!/^\/(?!\/)[a-zA-Z0-9/_-]*\/$/.test(root) && root !== '/') throw new Error('Invalid root');
        const response = await fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}, signal:controller.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json(), next = quantity(cart);
        if (ticket === epoch && !client) display(next, next !== null);
      } catch (_) { if (ticket === epoch && !client) display(null, false); }
      finally { clearTimeout(timeout); if (ticket === epoch) read = null; }
    }
    window.addEventListener('fec:cart-client-ready', attach);
    window.addEventListener('fec:cart-state', event => {
      attach(); const detail = event.detail;
      if (!client || detail?.source !== client || !Number.isSafeInteger(detail.revision) || detail.revision <= revision) return;
      revision = detail.revision;
      state(detail);
      if (detail.addition && !detail.busy && !detail.error && !detail.uncertain) celebrate();
    });
    document.addEventListener('close', () => { if (queued) celebrate(); }, true);
    const onReturn = () => {
      // BFCache pageshow and visibilitychange may describe the same return.
      if (returnTask !== null) return;
      returnTask = setTimeout(() => { returnTask = null; reconcile(); }, 0);
    };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') { queued = false; cancelPulse(); return; }
      onReturn();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) onReturn(); });
    const reduce = () => { if (motion.matches) { queued = false; cancelPulse(); } };
    if (motion.addEventListener) motion.addEventListener('change', reduce); else motion.addListener(reduce);
    const init = () => {
      if (initialized) return; initialized = true;
      const initial = links()[0]?.dataset.fecCartInitial;
      const parsed = /^\d+$/.test(initial || '') ? Number(initial) : null;
      display(Number.isSafeInteger(parsed) ? parsed : null, parsed !== null);
      // Defer/module scripts are now initialized; native pages own their initial refresh.
      if (!attach()) reconcile();
    };
    window.FECCartIndicator = Object.freeze({reconcile});
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  })();

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return

    const openMenus = document.querySelectorAll('.fec-site-header__menu[open]')
    openMenus.forEach((menu) => {
      menu.removeAttribute('open')
      menu.querySelector('summary')?.focus()
    })
  })
  } catch(e) { console.error(e); }
})();

})();
